import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Lock, AlertTriangle } from "lucide-react";
import { styles } from "../utils/globalStyles";

export default function SetDevice() {
  const [passcode, setPasscode] = useState("");
  const [status, setStatus] = useState(""); // 'success', 'error', 'removed'

  // --- KODE RAHASIA (Ganti dengan kata sandi yang hanya Anda tahu) ---
  const SECRET_CODE = "n1o5x1a0n2a0m1i7";

  const handleRegister = () => {
    if (passcode === SECRET_CODE) {
      // Tanamkan penanda 'TRUSTED_DEVICE' di LocalStorage browser ini
      localStorage.setItem("TRUSTED_DEVICE_KEY", "VERIFIED_ACCESS_GRANTED");
      setStatus("success");
    } else {
      setStatus("error");
    }
  };

  const handleRemove = () => {
    // Hapus penanda (untuk mencabut akses admin dari laptop ini)
    localStorage.removeItem("TRUSTED_DEVICE_KEY");
    setStatus("removed");
  };

  return (
    <div
      style={{
        ...styles.container,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "80vh",
      }}
    >
      <div style={styles.card}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div
            style={{
              background: "#F1F5F9",
              width: 60,
              height: 60,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 15px auto",
            }}
          >
            <Lock size={30} color="#334155" />
          </div>
          <h2 style={{ margin: 0, fontSize: 18 }}>
            Registrasi Perangkat Admin
          </h2>
          <p style={{ margin: "5px 0 0 0", fontSize: 13, color: "#64748B" }}>
            Halaman ini tersembunyi.
          </p>
        </div>

        {status === "success" ? (
          <div
            style={{
              textAlign: "center",
              background: "#F0FDF4",
              padding: 20,
              borderRadius: 12,
              border: "1px solid #BBF7D0",
            }}
          >
            <ShieldCheck
              size={48}
              color="#16A34A"
              style={{ display: "block", margin: "0 auto 10px auto" }}
            />
            <p style={{ fontWeight: "bold", color: "#166534", margin: 0 }}>
              BERHASIL!
            </p>
            <p style={{ fontSize: 13, color: "#166534" }}>
              Laptop ini sekarang diizinkan untuk login Admin.
            </p>
            <Link
              to="/"
              style={{
                display: "inline-block",
                marginTop: 15,
                textDecoration: "none",
                background: "#16A34A",
                color: "white",
                padding: "8px 20px",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: "bold",
              }}
            >
              Ke Halaman Login
            </Link>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
            <div style={{ textAlign: "left" }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: "bold",
                  display: "block",
                  marginBottom: 5,
                }}
              >
                Masukkan Kode Rahasia
              </label>
              <input
                type="password"
                placeholder="Ketikan kode..."
                style={styles.input}
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
              />
            </div>

            <button onClick={handleRegister} style={styles.primaryBtn}>
              Daftarkan Perangkat Ini
            </button>

            {status === "error" && (
              <p
                style={{
                  color: "#EF4444",
                  fontSize: 12,
                  textAlign: "center",
                  margin: 0,
                  fontWeight: "bold",
                }}
              >
                ⛔ Kode Salah! Akses ditolak.
              </p>
            )}

            <hr style={{ margin: "10px 0", borderTop: "1px solid #E2E8F0" }} />

            <button
              onClick={handleRemove}
              style={{
                background: "transparent",
                color: "#64748B",
                border: "1px dashed #CBD5E1",
                padding: 10,
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 5,
              }}
            >
              <AlertTriangle size={14} /> Hapus Izin dari Perangkat Ini
            </button>

            {status === "removed" && (
              <p
                style={{
                  color: "#F59E0B",
                  fontSize: 12,
                  textAlign: "center",
                  margin: 0,
                }}
              >
                Izin berhasil dihapus.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
